var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switcher",class:{checked: _vm.ownValue, disabled: _vm.disabled},on:{"click":function($event){_vm.ownValue = !_vm.ownValue}}},[_c('div',{staticClass:"switcher__slider"})])}
var staticRenderFns = []

export { render, staticRenderFns }